export default __webpack_public_path__ + "static/media/compossible-assemblages.ef9bb672.png";